import { InputConfigAction as _InputConfigAction } from "./inputReducer";
export { default, InputConfigActionTypes } from "./inputReducer";
export type InputConfigAction = _InputConfigAction;
